import { Tooltip, Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * Flags a trade whose sector/industry falls under a committee's oversight
 * jurisdiction. `conflicts` is the array the backend attaches to each trade
 * (`trade.conflicts`). Renders nothing when empty.
 *
 * Red = at least one `high`-confidence conflict; yellow = only `medium`.
 */
export default function ConflictBadge({ conflicts, size = 'small' }) {
    if (!conflicts || conflicts.length === 0) return null;

    const hasHigh = conflicts.some(c => c.confidence === 'high');
    const label = conflicts.length === 1 ? 'Conflict' : `${conflicts.length} conflicts`;
    const title = conflicts
        .map(c => `${c.committee_name} — ${c.matched_on}: ${c.matched_value}`)
        .join('\n');

    const palette = hasHigh
        ? { bg: 'rgba(239,68,68,0.12)', fg: '#fca5a5', border: 'rgba(239,68,68,0.35)' }
        : { bg: 'rgba(234,179,8,0.12)', fg: '#fde047', border: 'rgba(234,179,8,0.35)' };

    return (
        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{title}</span>} arrow>
            <Chip
                icon={<WarningAmberIcon sx={{ fontSize: 14 }} />}
                label={label}
                size={size}
                sx={{
                    height: 22,
                    fontSize: '0.6875rem',
                    fontWeight: 600,
                    letterSpacing: '0.02em',
                    bgcolor: palette.bg,
                    color: palette.fg,
                    border: `1px solid ${palette.border}`,
                    '.MuiChip-icon': { color: 'inherit', marginLeft: '4px' },
                }}
            />
        </Tooltip>
    );
}
